import { Input } from "@devhop/ui";
import { Search, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useBarcodeScanner } from "../hooks/useBarcodeScanner";

type ProductSearchBarProps = {
  value?: string;
  onChange: (value: string) => void;
  onBarcodeScan?: (barcode: string) => void;
  placeholder?: string;
  defaultValue?: string;
};

export function ProductSearchBar({
  value,
  onChange,
  onBarcodeScan,
  placeholder = "ຄົ້ນຫາສິນຄ້າ, SKU, ຫຼື Barcode...",
  defaultValue = "",
}: ProductSearchBarProps) {
  const [searchValue, setSearchValue] = useState(value ?? defaultValue);

  useEffect(() => {
    if (value !== undefined) {
      setSearchValue(value);
    }
  }, [value]);

  useBarcodeScanner({
    onScan: (barcode) => {
      if (onBarcodeScan) {
        onBarcodeScan(barcode);
      } else {
        onChange(barcode);
      }
    },
    minLength: 3,
    maxLength: 50,
  });

  const handleChange = (newValue: string) => {
    setSearchValue(newValue);
    onChange(newValue);
  };

  const handleClear = () => {
    setSearchValue("");
    onChange("");
  };

  return (
    <div className="relative">
      <Search className="absolute top-1/2 left-3.5 h-5 w-5 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="text"
        value={searchValue}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
        className="h-12 rounded-xl bg-card pr-11 pl-11 text-base shadow-sm"
      />
      {searchValue && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute top-1/2 right-3 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-muted-foreground hover:bg-accent hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
